import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import GroupedDropdown from './GroupedDropdown';

const UserSelectDropdown = ({
  users,
  selectedUserId,
  onSelect,
  ...props
}) => {
  const userGroups = useMemo(() => {
    let obj = {
      'Employees': [],
      'Parents': []
    };

    // NOTE: will need to update the option value or K2 since the `parent|employee-[id]` is for legacy
    users.employees.forEach(emp => {
      const { id, name } = emp;
      const reactComponent = <option key={`emp-${id}`} value={`employee-${id}`}>{name}</option>;

      obj['Employees'].push(reactComponent);
    });

    users.parents.forEach(parent => {
      const { id, name } = parent;
      const reactComponent = <option key={`parent-${id}`} value={`parent-${id}`}>{name}</option>;

      obj['Parents'].push(reactComponent);
    });

    return obj;
  }, [users]);

  return (
    <GroupedDropdown
      groups={userGroups}
      label='User'
      selected={selectedUserId}
      onSelect={onSelect}
    />
  );
};

UserSelectDropdown.propTypes = {
  users: PropTypes.shape({
    parents: PropTypes.array,
    employees: PropTypes.array
  }),
  selectedChannelId: PropTypes.string,
  onSelect: PropTypes.func
};

export default UserSelectDropdown;
